import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  CompanyPreviewParams,
  CompanyPreviewResponse,
} from "@/api/types/companyPreview";

export async function getCompanyPreview(
  params: CompanyPreviewParams
): Promise<CompanyPreviewResponse> {
  const { data, error } = await supabase.functions.invoke(
    `api/company-preview?cui=${encodeURIComponent(params.cui)}`,
    { method: "GET" }
  );

  if (error) {
    const status = (error as { context?: { status?: number } } | null)?.context
      ?.status;
    try {
      await handleSupabaseFunctionError(error);
    } catch (eroare) {
      if (eroare instanceof Error) {
        (eroare as Error & { status?: number }).status = status;
      }
      throw eroare;
    }
  }
  return data;
}
